// extracted by mini-css-extract-plugin
export default {"title":"style_title__f0uvu","balloon":"style_balloon__Bwm1O"};